// @ts-strict-ignore
import { Body, Heading } from "components/parts/Typography";
import styled from "styled-components";
import { Colors } from "themes/color-palette";
import darkTheme from "themes/dark";

export const SubHeading = styled(Heading)`
  color: ${darkTheme.textColors.secondary};
  text-transform: uppercase;
`;

export const SubBodyHeading = styled(Body)`
  color: ${darkTheme.textColors.secondary};
  text-transform: uppercase;
`;
export const SubMenuHeadline = styled(Body).attrs({ size: "lg", m: "0" })`
  display: inline;
  position: relative;
  // Avoid chaning font color when is dark theme
  color: ${(props) => props.style?.color || darkTheme.textColors.primary};
`;

export const SubMenuContainer = styled.div`
  margin: ${({ style }) => style?.margin || "24px auto 0px 0px"};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  cursor: pointer;

  .user-is-tabbing &:focus-within a:focus {
    outline: none;
  }
`;

export const SubMenuDescription = styled(Body).attrs({
  size: "sm",
  m: "0px 0 0 0",
  color: Colors.gray[300]
})``;

export const SubMenuLink = styled.div`
  margin-top: 15px;
  font-size: 18px;
  color: ${({ theme }) => theme.textColors.primary};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

export const SubMenuText = styled(Body).attrs({
  size: "xs",
  m: "0",
  semiBold: true
})`
  text-transform: uppercase;
  padding: 0 0 0 12px;
  display: inline;
`;
